import ReactDOM from 'react-dom'
import { FCC } from 'sierra-client/types'

export const Portal: FCC = ({ children }) => {
  return typeof document === 'object' ? ReactDOM.createPortal(children, document.body) : null
}
